/*
 * REAXION theme — 最小限のインタラクション
 * Next.js版の RevealProvider / SiteHeader のスクロール挙動を移植したもの。
 */
;(function () {
  'use strict'

  /* スクロールでヘッダーを不透明にする */
  function initHeader() {
    var header = document.querySelector('[data-header]')
    if (!header) return

    // ヒーローが濃色でないページでは最初から不透明にする
    if (header.getAttribute('data-force-solid') === 'true') {
      header.classList.add('is-solid')
      return
    }

    var onScroll = function () {
      header.classList.toggle('is-solid', window.scrollY > 24)
    }
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
  }

  /* モバイルメニューの開閉 */
  function initMobileNav() {
    var toggle = document.querySelector('[data-nav-toggle]')
    var panel = document.querySelector('[data-nav-panel]')
    var header = document.querySelector('[data-header]')
    if (!toggle || !panel) return

    toggle.addEventListener('click', function () {
      var open = panel.hasAttribute('hidden')
      if (open) {
        panel.removeAttribute('hidden')
        if (header) header.classList.add('is-solid')
      } else {
        panel.setAttribute('hidden', '')
      }
      toggle.setAttribute('aria-expanded', String(open))
      document.body.style.overflow = open ? 'hidden' : ''
    })
  }

  /* スクロールで要素をフェードインさせる */
  function initReveal() {
    var targets = document.querySelectorAll('.js-reveal')
    if (!targets.length) return

    // IntersectionObserver が無い環境では常に表示しておく
    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.classList.add('is-in')
      })
      return
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return
          entry.target.classList.add('is-in')
          observer.unobserve(entry.target)
        })
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.05 },
    )

    targets.forEach(function (el) {
      observer.observe(el)
    })
  }

  /* 商品ページのギャラリー切り替え */
  function initProductGallery() {
    var main = document.getElementById('pdp-main-image')
    var thumbs = document.querySelectorAll('.js-pdp-thumb')
    if (!main || !thumbs.length) return

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        main.src = thumb.dataset.src
        main.alt = thumb.dataset.alt || ''
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', t === thumb)
        })
      })
    })
  }

  function init() {
    initHeader()
    initMobileNav()
    initReveal()
    initProductGallery()
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }
})()
